@if ((isLoading | async) || (isPageLoading | async)) {
<div class="overlay">
  <mat-progress-spinner class="spinner" mode="indeterminate">
  </mat-progress-spinner>
</div>
}
